// extracted by mini-css-extract-plugin
module.exports = {"excelExport":"excelBtn__excelExport__2mpYe","iconExport":"excelBtn__iconExport__2LFWN"};